import React from 'react';

export const inputClass =
  'w-full rounded-lg border border-[#d0d5dd] bg-white px-3 text-sm text-[#212B36] placeholder:text-[#9aa3ab] focus:border-[#0061B2] focus:outline-none focus:ring-2 focus:ring-[#0061B2]/15 disabled:cursor-not-allowed disabled:bg-[#FAFBFE] disabled:text-[#9aa3ab]';

const HEIGHTS = { sm: 'h-8', md: 'h-9', lg: 'h-11' };

const filterFieldClass =
  'w-full rounded-[10px] border border-[#E9EDF6] bg-[#FAFBFE] px-3 text-sm text-[#212B36] placeholder:text-[#637381] focus:border-[#0061B2] focus:outline-none focus:ring-2 focus:ring-[#0061B2]/15 disabled:cursor-not-allowed disabled:bg-[#FAFBFE] disabled:text-[#9aa3ab]';

const Input = React.forwardRef(
  (
    {
      label,
      required = false,
      error = false,
      helperText,
      startIcon = null,
      endIcon = null,
      size = 'md',
      fullWidth = true,
      className = '',
      wrapperClassName = '',
      filterBarMatch = false,
      ...rest
    },
    ref
  ) => {
    const h = filterBarMatch ? 'h-10' : HEIGHTS[size === 'small' ? 'sm' : size] || HEIGHTS.md;
    const baseFieldClass = filterBarMatch ? filterFieldClass : inputClass;
    const hasError = !!error;
    // Support error as string: render it as helper text automatically
    const effectiveHelperText = helperText || (typeof error === 'string' && error ? error : null);
    const errorClass = hasError
      ? 'border-[#EF4444] focus:border-[#EF4444] focus:ring-[#EF4444]/15'
      : '';

    return (
      <div className={`${fullWidth ? 'w-full' : ''} ${wrapperClassName}`}>
        {label && (
          <label className={filterBarMatch ? 'mb-1.5 block text-xs font-semibold text-[#212B36]' : 'mb-1 block text-[13px] font-medium text-[#212B36]'}>
            {label}
            {required && <span className="ml-0.5 text-[#EF4444]">*</span>}
          </label>
        )}
        <div className="relative">
          {startIcon && (
            <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-[#9aa3ab]">
              {startIcon}
            </span>
          )}
          <input
            ref={ref}
            className={`${baseFieldClass} ${h} ${startIcon ? 'pl-9' : ''} ${
              endIcon ? 'pr-9' : ''
            } ${errorClass} ${className}`}
            {...rest}
          />
          {endIcon && (
            <span className="absolute right-2.5 top-1/2 -translate-y-1/2 text-[#9aa3ab]">
              {endIcon}
            </span>
          )}
        </div>
        {effectiveHelperText && (
          <p className={`mt-1 text-xs ${hasError ? 'text-[#EF4444]' : 'text-[#637381]'}`}>
            {effectiveHelperText}
          </p>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';
export default Input;
